@if(useNewSearchHeader) {
  <app-search-results-header
    [filters]="selectedFilters"
    [searchTerm]="_searchTerm"
    [filterSidebarToggle]="filterSidebarToggleSignal"
    [isMobile$]="isMobile$"
    [showSearchResults]="false"
    [initialDateRange]="currentDateRange"
    (toggleFilters)="onToggleFilters()"
    (clearFilters)="clearFilters()"
    (dateRangeChanged)="onDateRangeChanged($event)"
    [isClearButtonShown]="true"
  >
  </app-search-results-header>
} @else {
  <section
    class="tab-bar"
    [class.no-filters]="!showFilters"
    [class.empty-section-unified]="!moreThanOneTab"
  >
    <div
      class="filter-sidebar-header"
      [class.collapsed]="filtersCollapsed"
      *ngIf="showFilters"
    >
      <em class="icon-sidebar_close" (click)="onToggleFilters()"></em>
      <span>Filters</span>
      <span class="clear-all" (click)="clearFilters()" *ngIf="filtersApplied">
        <em class="icon-close_small"></em>
        Clear All
      </span>
    </div>

    <div class="tab-bar horizontal-scrollbar" *ngIf="moreThanOneTab">
      <div *ngFor="let group of tabGroups; let first = first" class="tab-group">
        <div
          *ngIf="
            !first &&
            (getShowedTabs(group.tabs) | async).length > 0
          "
          class="divider"
        ></div>

        <ng-container *ngFor="let tab of (getFilteredTabs(group.tabs) | async)">
          <div
            *ngIf="!tab.hide"
            class="tab"
            [class.active]="tab === activeTab"
            (click)="onClickTab(tab, group.id)"
          >
            {{ tab.name }}{{ tab.count >= 0 ? ' (' + tab.count + ')' : '' }}
          </div>
        </ng-container>
      </div>
    </div>

    <div class="tab-bar pagination-top-container" *ngIf="!moreThanOneTab">
      <app-pagination-top
        *ngIf="showPagination"
        [sortOptions]="sortOptions"
        [selectedSort]="currentSelectedSort"
        [showSort]="showSort"
        [count]="count"
        [currentPage]="page"
        [pageSize]="pageSize"
        [pageSizes]="pageSizes"
        [showHighlights]="showHighlights"
        (changePaginationOptions)="onChangePaginationOptions($event)"
      ></app-pagination-top>
    </div>
  </section>
}
<section class="analysis-view">
  <aside class="sidebar-wrapper" [class.collapsed]="filtersCollapsed" *ngIf="showFilters">
    <app-filter-sidebar
      class="scrollbar"
      [filters]="filters"
      (changeFilters)="onFiltersChanged($event)"
      #filtersBar
    ></app-filter-sidebar>
  </aside>

  <div class="analysis-view-container" [class.collapsed]="filtersCollapsed">
    @if(moreThanOneTab) {
      <app-pagination-top
        *ngIf="showPagination"
        [sortOptions]="sortOptions"
        [selectedSort]="currentSelectedSort"
        [showSort]="showSort"
        [count]="count"
        [currentPage]="page"
        [pageSize]="pageSize"
        [pageSizes]="pageSizes"
        [showHighlights]="showHighlights"
        (changePaginationOptions)="onChangePaginationOptions($event)"
      ></app-pagination-top>
    }

    <div *ngIf="!loading">
      @if(useNewSearchHeader) {
        <div class="new-search-header">
          <div class="results-section">
            <div class="results-text" *ngIf="showResultsText; else noResultsText">
              <strong class="results-count">
                {{ (count > 10000 ? 10000 : count) | numberString }}
                {{
                  activeTab?.name === 'Videos'
                    ? 'Video'
                    : activeTab?.name === 'unifiedContent'
                      ? ''
                      : activeTab?.name
                }}
                results
              </strong>
              <strong *ngIf="_searchTerm && count !== undefined" class="results-for">for</strong>
              <span *ngIf="_searchTerm && count !== undefined" class="search-term">
                "{{ _searchTerm }}"
              </span>
              <span
                *ngIf="breadcrumbString && breadcrumbString != 'Search All'"
                class="breadcrumb-context"
              >in {{ breadcrumbString }}</span>
              <span
                *ngIf="count > 10000"
                [ngClass]="iconClassInfo"
                class="info-tooltip"
                [ngbTooltip]="maxAmountResultsExceededMessage"
                placement="top"
                container="body"
              ></span>
            </div>
            <ng-template #noResultsText>
              <div class="results-text-hidden"></div>
            </ng-template>
          </div>

          <div class="sort-section">
            <app-sort-by
              [sortOptions]="sortOptions"
              [selectedSort]="currentSelectedSort"
              (sortChanged)="onChangePaginationOptions($event)"
            ></app-sort-by>
          </div>
        </div>
      } @else {
        <div class="search-string-highlight-wrapper">
          <div class="results-text" *ngIf="showResultsText; else noResultsTextLegacy">
            <strong>
              {{ (count > 10000 ? 10000 : count) | numberString }}
              {{
                activeTab?.name === 'Videos'
                  ? 'Video'
                  : activeTab?.name === 'unifiedContent'
                    ? ''
                    : activeTab?.name
              }}
              results
            </strong>
            <strong *ngIf="_searchTerm && count !== undefined">for</strong>
            <span *ngIf="_searchTerm && count !== undefined" class="results-text-normal">
              "{{ _searchTerm }}"
            </span>
            <span
              *ngIf="breadcrumbString && breadcrumbString != 'Search All'"
              class="breadcrum-message-container results-text-normal"
            >in {{ breadcrumbString }}</span>
            <span
              *ngIf="count > 10000"
              [ngClass]="iconClassInfo"
              class="tooltip-span-container results-text-normal"
              [ngbTooltip]="maxAmountResultsExceededMessage"
              placement="top"
              container="body"
            ></span>
          </div>
          <ng-template #noResultsTextLegacy>
            <div class="results-text-hidden"></div>
          </ng-template>

          <app-pagination-highlight
            *ngIf="showHighlightToggle"
            [currentPage]="page"
            [currentPageSize]="pageSize"
            [selectedSort]="currentSelectedSort"
            [showHighlights]="showHighlights"
            (changePaginationOptions)="onChangePaginationOptions($event)"
          ></app-pagination-highlight>
        </div>
      }
    </div>

    <div class="loading-indicator" *ngIf="loading; else loaded">
      <app-progress-bar-circular></app-progress-bar-circular>
    </div>

    <ng-template #loaded>
      <ng-container [ngTemplateOutlet]="activeTabGroup.template"></ng-container>
    </ng-template>

    @if(showPagination) {
      <app-pagination-bottom
        [count]="count"
        [startingPage]="page"
        [startingPageSize]="pageSize"
        [selectedSort]="currentSelectedSort"
        [showHighlights]="showHighlights"
        (changePaginationOptions)="onChangePaginationOptions($event)"
      ></app-pagination-bottom>
    }
  </div>
</section>
